import { Observable } from 'rxjs'
import { favourites, favouritesByName, searchFavourites, remove } from '../services/favourite'
import * as authenticationDuck from 'store/ducks/authentication'
import { combineEpics } from 'redux-observable'
import { alertSuccess } from 'store/ducks/alert'
import { intl } from 'i18n'

export const FAVOURITES_REQUEST = 'favourites/FAVOURITES_REQUEST'
export const FAVOURITES_SUCCESS = 'favourites/FAVOURITES_SUCCESS'
export const FAVOURITES_FAILURE = 'favourites/FAVOURITES_FAILURE'

export const DELETE_REQUEST = 'favourites/DELETE_REQUEST'
export const DELETE_SUCCESS = 'favourites/DELETE_SUCCESS'
export const DELETE_FAILURE = 'favourites/DELETE_FAILURE'

export const FAVOURITES_NAME_REQUEST = 'favourites/FAVOURITES_NAME_REQUEST'

export const FETCH_SEARCH_REQUEST = 'favourites/FETCH_SEARCH_REQUEST'

// Reducer
const INITIAL_STATE = {
  favourites: [],
  isLoading: false,
  total: null,
}

export function reducer(state = INITIAL_STATE, action = {}) {
  switch (action.type) {
    case FAVOURITES_REQUEST:
    case FAVOURITES_NAME_REQUEST:
      return {
        ...state,
        isLoading: true,
      }
    case FAVOURITES_SUCCESS:
      return {
        ...state,
        favourites: action.items,
        isLoading: false,
        total: action.total,
      }
    case FAVOURITES_FAILURE:
      return {
        ...state,
        isLoading: false,
      }
    case authenticationDuck.LOGOUT_SUCCESS:
      return {
        ...INITIAL_STATE,
      }
    case FETCH_SEARCH_REQUEST:
      return {
        ...state,
        isLoading: true,
      }

    case DELETE_REQUEST:
      return {
        ...state,
        isLoading: true,
      }
    case DELETE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        favourites: [
          ...state.favourites.filter((favourite) => {
            return favourite.id !== action.payload
          }),
        ],
      }
    case DELETE_FAILURE:
      return {
        ...state,
        isLoading: false,
      }

    default:
      return state
  }
}

export const favouritesRequest = (pageNumber, itemsPerPage) => {
  return {
    type: FAVOURITES_REQUEST,
    pageNumber,
    itemsPerPage,
  }
}

export const favouritesByNameRequest = (name) => {
  return {
    type: FAVOURITES_NAME_REQUEST,
    name,
  }
}

export const favouritesSuccess = (result) => {
  const items = result['hydra:member'].map((entity) => entity)
  return {
    type: FAVOURITES_SUCCESS,
    items,
    total: result['hydra:totalItems'],
  }
}

export const favouritesFailure = (errors) => ({
  type: FAVOURITES_FAILURE,
  errors,
})

export const favouritesSearch = (payload) => {
  return {
    type: FETCH_SEARCH_REQUEST,
    payload,
  }
}

export const deleteFavourite = (id) => {
  return {
    type: DELETE_REQUEST,
    id,
  }
}

export const deleteSuccess = (payload) => {
  return {
    type: DELETE_SUCCESS,
    payload,
  }
}

export const deleteFailure = () => {
  return {
    type: DELETE_FAILURE,
  }
}

export const epic = combineEpics(
  deliveriesFavouritesRequestEpic,
  deliveriesFavouritesByNameRequestEpic,
  fetchBySearchRequestEpic,
  deliveriesFavouritesDeleteEpic,
)

export function deliveriesFavouritesRequestEpic(action$) {
  return action$.ofType(FAVOURITES_REQUEST).mergeMap((action) =>
    Observable.ajax(favourites({ params: { pageNumber: action.pageNumber, itemsPerPage: action.itemsPerPage } }))
      .mergeMap((res) => Observable.of(favouritesSuccess(res.response), ...(!res.response.length ? [] : [])))
      .catch((err) => {
        if (typeof err === 'object' && (err.response || {}).code === 401) {
          return Observable.of(authenticationDuck.refreshTokenRequest(action))
        }

        return Observable.of(favouritesFailure())
      }),
  )
}

export function deliveriesFavouritesByNameRequestEpic(action$) {
  return action$.ofType(FAVOURITES_NAME_REQUEST).mergeMap((action) =>
    Observable.ajax(favouritesByName(action.name))
      .mergeMap((res) => Observable.of(favouritesSuccess(res.response), ...(!res.response.length ? [] : [])))
      .catch((err) => {
        if (typeof err === 'object' && (err.response || {}).code === 401) {
          return Observable.of(authenticationDuck.refreshTokenRequest(action))
        }

        return Observable.of(favouritesFailure())
      }),
  )
}

export function fetchBySearchRequestEpic(action$) {
  return action$.ofType(FETCH_SEARCH_REQUEST).mergeMap((action) =>
    Observable.ajax(searchFavourites({ params: action.payload }))
      .map((res) => favouritesSuccess(res.response))
      .catch((err) => {
        if (typeof err === 'object' && (err.response || {}).code === 401) {
          return Observable.of(authenticationDuck.refreshTokenRequest(action))
        }

        return Observable.of(favouritesFailure())
      }),
  )
}

export function deliveriesFavouritesDeleteEpic(action$) {
  return action$.ofType(DELETE_REQUEST).mergeMap((action) =>
    Observable.ajax(remove(action.id))
      .mergeMap((res) =>
        Observable.of(
          deleteSuccess(action.id),
          alertSuccess(intl.formatMessage({ id: 'ducks.favourites.delete.success' })),
        ),
      )
      .catch((err) => {
        if (typeof err === 'object' && (err.response || {}).code === 401) {
          return Observable.of(authenticationDuck.refreshTokenRequest(action))
        }

        return Observable.of(deleteFailure())
      }),
  )
}
